import { Controller } from "@hotwired/stimulus"
import { Chart, registerables } from "chart.js"

Chart.register(...registerables)

export default class extends Controller {
  static targets = ["canvas"]

  static values = {
    data: Array,
    color: { type: String, default: "#6366f1" },
    height: { type: Number, default: 30 }
  }

  connect() {
    this.chart = null
    this.render()
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
    }
  }

  render() {
    if (!this.hasCanvasTarget || !this.dataValue || this.dataValue.length === 0) {
      return
    }

    const ctx = this.canvasTarget.getContext("2d")

    this.chart = new Chart(ctx, {
      type: "line",
      data: {
        labels: this.dataValue.map((_, i) => i),
        datasets: [{
          data: this.dataValue,
          borderColor: this.colorValue,
          backgroundColor: this.hexToRgba(this.colorValue, 0.1),
          borderWidth: 1.5,
          fill: true,
          tension: 0.4,
          pointRadius: 0
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: { enabled: false }
        },
        scales: {
          x: { display: false },
          y: { display: false }
        },
        elements: {
          line: {
            borderCapStyle: "round"
          }
        }
      }
    })
  }

  hexToRgba(hex, alpha) {
    const r = parseInt(hex.slice(1, 3), 16)
    const g = parseInt(hex.slice(3, 5), 16)
    const b = parseInt(hex.slice(5, 7), 16)
    return `rgba(${r}, ${g}, ${b}, ${alpha})`
  }

  updateData(newData) {
    this.dataValue = newData
    if (this.chart) {
      this.chart.data.labels = newData.map((_, i) => i)
      this.chart.data.datasets[0].data = newData
      this.chart.update("none")
    }
  }
}
